import React from "react"
import {IProps as IScreenProps, Screen} from '~common/screen';
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'
import Form from '~/components/form'

interface IProps {
  screenProps?: IScreenProps
}

const QuestionsScreenV2: React.FC<IProps> = (props) => {
  return (
    <Screen
      id='ask_us'
      title={<span>Попробуйте 7 дней <StyledScreen.GreenText>бесплатно</StyledScreen.GreenText></span>}
      bottomLine={true}
      {...props.screenProps}
    >
      <Styled.FormWrapper>
        <Form
          formType='service'
          text='Попробовать сервис'
          pageName='Главная'
        />
      </Styled.FormWrapper>
    </Screen>
  )
}

export { QuestionsScreenV2 }
